// Utils
import { visitItems } from 'modules/discover/graphql/utils'

// Types
import type { SectionFragment } from '@sketch/gql-types'
import { LocalResolver } from '@sketch/gql-types/resolvers'

// Constants
const HEADERS = {
  'x-client-name': 'cloud-frontend',
  'x-client-version': (process.env.REACT_APP_RELEASE_VERSION ||
    process.env.REACT_APP_COMMIT_HASH) as string,
  'Content-Type': 'application/json',
}

export const sections: LocalResolver<'Discover'>['sections'] = async () => {
  const response = await fetch('/data/discover.json', {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const responseJson = await response.json()

    return visitItems(responseJson.sections) as SectionFragment[]
  }

  throw new Error('Something went wrong')
}

export const contentHash: LocalResolver<'Discover'>['contentHash'] = async () => {
  const response = await fetch('/data/discover-hash.json', {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const responseJson = await response.json()

    return responseJson.hash
  }

  throw new Error('Something went wrong')
}
